import React from "react";

const UserSelectedContext = React.createContext({});

export default UserSelectedContext